"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = require("react"),
    r = (e = t) && "object" == typeof e && "default" in e ? e.default : e;

function n(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function o() {
  return (o = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function i(e, t) {
  var r = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }

  return r;
}

function a(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? i(Object(r), !0).forEach(function (t) {
      n(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }

  return e;
}

function c(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
    var r = [],
        n = !0,
        o = !1,
        i = void 0;

    try {
      for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        n || null == c.return || c.return();
      } finally {
        if (o) throw i;
      }
    }

    return r;
  }(e, t) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return l(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === r && e.constructor && (r = e.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(r);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return l(e, t);
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function l(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var r = 0, n = new Array(t); r < t; r++) {
    n[r] = e[r];
  }

  return n;
}

var u = function u(e) {
  var n,
      o,
      i,
      c = e.style,
      l = e.navStyle,
      u = e.children,
      s = e.showNav,
      p = e.openFromRight,
      y = e.onHideNav,
      m = t.useRef(),
      h = function h() {
    y && y();
  },
      v = function e() {
    if (i) {
      requestAnimationFrame(e);
      var t = Math[p ? "max" : "min"](0, o - n);
      m.current.style.transform = "translateX(".concat(t, "px)");
    }
  },
      d = {
    root: a({
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      position: "fixed",
      overflow: "hidden",
      zIndex: 8,
      pointerEvents: s ? "auto" : "none"
    }, c || {}),
    nav: a({
      position: "relative",
      width: "90%",
      maxWidth: 400,
      height: "100%",
      background: "#FFF",
      boxShadow: "2px 0 12px rgba(0,0,0,0.4)",
      transform: s ? "none" : "translateX(".concat(p ? 102 : -102, "%)"),
      transition: "transform ".concat(s ? "0.33s" : "0.13s", " cubic-bezier(0,0,0.3,1)"),
      display: "flex",
      willChange: "transform",
      flexDirection: "column",
      float: p ? "right" : "left"
    }, l || {}),
    overlay: {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      opacity: s ? 1 : 0,
      background: "rgba(0,0,0,0.4)",
      transition: "opacity 0.3s cubic-bezier(0, 0, 0.3, 1)",
      willChange: "opacity"
    }
  };

  return r.createElement("aside", {
    style: d.root
  }, r.createElement("div", {
    style: d.overlay,
    onClick: h
  }), r.createElement("nav", {
    style: d.nav,
    onTransitionEnd: function onTransitionEnd(e) {
      e.target.style.transition = "none";
    },
    onTouchStart: function onTouchStart(e) {
      n = o = e.touches[0].pageX, i = !0, requestAnimationFrame(v);
    },
    onTouchMove: function onTouchMove(e) {
      i && (o = e.touches[0].pageX);
    },
    onTouchEnd: function onTouchEnd(e) {
      if (i) {
        i = !1;
        var t = Math[p ? "max" : "min"](0, o - n);
        m.current.style.transform = "", !p && t < 0 && h(), p && t > 0 && h();
      }
    },
    ref: m
  }, u || r.createElement(f, e)));
},
    f = function f(e) {
  var n = e.titleStyle,
      o = e.itemStyle,
      i = e.itemHoverStyle,
      l = e.title,
      u = e.items,
      f = c(t.useState(), 2),
      s = f[0],
      p = f[1],
      y = function y(e, t, r) {
    if (t) return p(r);
    p();
  },
      m = function m(e) {
    return a({
      padding: "22px",
      cursor: "pointer",
      backgroundColor: "#fff"
    }, o || {}, {}, e === s ? i || {
      backgroundColor: "#f5f5f5"
    } : {});
  },
      h = a({
    background: "#E91E63",
    color: "#fff",
    fontWeight: 400,
    margin: 0,
    lineHeight: "82px",
    padding: 22
  }, n || {});

  return r.createElement("div", null, r.createElement("h1", {
    style: h
  }, l || "Simple SideNav"), r.createElement("ul", null, u ? u.map(function (e, t) {
    return r.createElement("li", {
      key: "item" + t,
      style: m(t),
      onMouseOver: function onMouseOver(e) {
        return y(0, !0, t);
      },
      onMouseOut: function onMouseOut(e) {
        return y(0, !1);
      }
    }, e);
  }) : r.createElement("li", {
    key: "item1",
    style: m(1)
  }, "Item 1")));
};

exports.MenuIcon = function (e) {
  return r.createElement("svg", o({}, e, {
    xmlns: "http://www.w3.org/2000/svg",
    cursor: "pointer",
    fill: "#fff",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24"
  }), r.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), r.createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
  }));
}, exports.SideNav = u, exports.default = u;